export default __webpack_public_path__ + "static/media/Stone-2.9b96cd81.gif";